// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2mH0M","title":"FrontImage_title__cvt84"};